module.exports = __webpack_public_path__ + "img/app-preview.3946798c.webp";